export class ToolsGPXStats {
    constructor(public dist:number, public distEffort:number, public sumElePos:number, public sumEleNeg:number, public points: Array<Array<String>>) {
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/tools-gpx-stats.ts